import { Col, Row, Tooltip } from "antd";
import React, { useState } from "react";
import SearchControl from "../../../../../components/SearchControls/SearchGroups/SearchControl";
import { getIconUrl } from "../../../../../services/asset";
import styles from "./style.scss";
import { Button } from "../../../../../components/Button/Button";
const ModuleSearchGroup = props => {
  const {
    groupConfig,
    form,
    onSubmit,
    onReset,
    isMobile,
    renderCategorySelector,
    showAllControls,
    hideSearchButton
  } = props;

  return (
    <React.Fragment>
      <Row style={{ width: "100%" }}>
        <Row type="flex" gutter={hideSearchButton ? [12, 12] : 12}>
          <Col span={6} className={hideSearchButton ? styles.categoryColCompact : undefined}>{renderCategorySelector()}</Col>
          {groupConfig.controls.map((controlConfig, index) => (
            <Col key={index} span={6} style={{ marginBottom: 15}}>
              <SearchControl
                form={form}
                controlConfig={controlConfig}
                isMobile={isMobile}
                onSubmit={onSubmit}
                showPlaceholder={true}
                showAllControls={showAllControls}
              />
            </Col>
          ))}
          {!showAllControls && !hideSearchButton && (
            <Col span={6} className={styles.searchBtnCol}>
              {onReset && (
                <Tooltip title="Resetiraj filtere">
                  <span className={styles.resetBtn} onClick={onReset}>
                    <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
                  </span>
                </Tooltip>
              )}
              <Button
                type="primary"
                className={`uppercase ${styles.searchButton}`}
                onClick={onSubmit}
              >
                <img
                  alt={"Traži"}
                  src={getIconUrl("search-white.svg")}
                />
                {"Traži"}
              </Button>
            </Col>
          )}
        </Row>
      </Row>
    </React.Fragment>
  );
};

export default ModuleSearchGroup;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleSearchGroups/ModuleSearchGroup/index.tsx